import Progress from 'redux-progress';

import {
  EVALUATION_PRODUCTS,
  CURRENT_PRODUCT_PACKAGE,
  PRODUCT_PACKAGES_BY_KEYS,
  BTF_PRODUCT_PACKAGE,
  PRODUCT_PACKAGE,
  PRODUCT_OFFERING_KEY_MAPPING,
} from '../actions/product';
import { MACProductAction, MACProductState } from '../models/product';

export const initialState = {
  productPackages: Progress.none,
  evaluationProducts: Progress.none,
  currentProductPackage: Progress.none,
  btfProductPackageAvailableForEvaluation: Progress.none,
  productPackage: Progress.none,
  productOfferingKeyMapping: Progress.none,
};

export default (
  state: MACProductState = initialState,
  action: MACProductAction,
): MACProductState => {
  switch (action.type) {
    case PRODUCT_PACKAGES_BY_KEYS:
      return {
        ...state,
        productPackages: action.progress,
      };
    case EVALUATION_PRODUCTS:
      return {
        ...state,
        evaluationProducts: action.progress,
      };
    case CURRENT_PRODUCT_PACKAGE:
      return {
        ...state,
        currentProductPackage: {
          ...state.currentProductPackage,
          [action.productKey]: action.progress,
        },
      };
    case BTF_PRODUCT_PACKAGE:
      return {
        ...state,
        btfProductPackageAvailableForEvaluation: {
          ...state.btfProductPackageAvailableForEvaluation,
          [action.addOnKey]: action.progress,
        },
      };
    case PRODUCT_PACKAGE:
      return {
        ...state,
        productPackage: {
          ...state.productPackage,
          [action.productPackageId]: action.progress,
        },
      };
    case PRODUCT_OFFERING_KEY_MAPPING:
      return {
        ...state,
        productOfferingKeyMapping: action.progress,
      };
    default:
      return state;
  }
};
